import { createContext, useState } from 'react';

export const EosSourcesFilterContext = createContext<{
  sources: string[];
  setSources: (sources: string[]) => void;
}>({ sources: [], setSources: () => {} });

export function EosSourcesFilterContextProvider({
  children,
  defaultSources = [],
  selectionMode = 'multi',
}: {
  children: React.ReactNode;
  defaultSources?: string[];
  selectionMode?: 'single' | 'multi';
}) {
  const [sources, setSources] = useState<string[]>(defaultSources);

  const handleSetSources = (newSources: string[]) => {
    if (selectionMode === 'single') {
      if (newSources.length > 0 && !newSources.every((s) => sources.includes(s))) {
        setSources(newSources);
      }
    } else {
      setSources((prev) =>
        newSources.some((source) => prev.includes(source))
          ? prev.filter((source) => !newSources.includes(source))
          : [...prev, ...newSources],
      );
    }
  };

  return (
    <EosSourcesFilterContext.Provider value={{ sources, setSources: handleSetSources }}>
      {children}
    </EosSourcesFilterContext.Provider>
  );
}
